// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Saved Charts Container */
.saved-charts-container {
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.8) 0%, rgba(22, 33, 62, 0.8) 100%);
  border: 1px solid rgba(74, 124, 126, 0.3);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  animation: slideDown 0.3s ease-out;
  width: 100%;
  max-width: 400px;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Header */
.saved-charts-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(74, 124, 126, 0.2);
}

.saved-charts-header h3 {
  margin: 0;
  color: #fff;
  font-family: 'Orbitron', monospace;
  font-size: 16px;
  font-weight: 700;
  background: linear-gradient(135deg, #4a7c7e 0%, #7eb3b5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Refresh Button */
.refresh-charts-btn {
  background: linear-gradient(135deg, #4a7c7e 0%, #7eb3b5 100%);
  color: #000;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  font-family: 'Orbitron', monospace;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.refresh-charts-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(126, 179, 181, 0.3);
}

.refresh-charts-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Loading State */
.saved-charts-loading,
.saved-charts-loading-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 20px;
  gap: 12px;
}

.saved-charts-loading p,
.saved-charts-loading-details p {
  color: #aaa;
  font-family: 'Orbitron', monospace;
  font-size: 13px;
  margin: 0;
}

/* Spinner */
.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(74, 124, 126, 0.3);
  border-top: 3px solid #7eb3b5;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Empty State */
.saved-charts-empty {
  padding: 20px;
  text-align: center;
  color: #999;
  font-family: 'Orbitron', monospace;
  font-size: 13px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin: 10px 0;
}

/* Dropdown Wrapper */
.saved-charts-dropdown-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

/* Label */
.saved-charts-label {
  color: #ccc;
  font-family: 'Orbitron', monospace;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Dropdown */
.saved-charts-dropdown {
  width: 100%;
  padding: 10px 14px;
  border: 2px solid #4a7c7e;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  font-family: 'Orbitron', monospace;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.saved-charts-dropdown:focus {
  outline: none;
  border-color: #7eb3b5;
  background: rgba(74, 124, 126, 0.1);
  box-shadow: 0 0 10px rgba(126, 179, 181, 0.3);
}

.saved-charts-dropdown:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.saved-charts-dropdown option {
  background: #16213e;
  color: #fff;
  padding: 8px;
}

/* Error Message */
.saved-charts-error {
  background: rgba(244, 67, 54, 0.1);
  border: 1px solid rgba(244, 67, 54, 0.3);
  color: #ff9999;
  padding: 12px;
  border-radius: 8px;
  font-family: 'Orbitron', monospace;
  font-size: 12px;
  margin: 12px 0;
}

/* Info Message */
.saved-charts-info {
  background: rgba(76, 175, 80, 0.1);
  border: 1px solid rgba(76, 175, 80, 0.3);
  color: #9cff9c;
  padding: 12px;
  border-radius: 8px;
  font-family: 'Orbitron', monospace;
  font-size: 12px;
  margin: 12px 0;
  animation: slideDown 0.3s ease-out;
}

.saved-charts-info .info-text {
  margin: 0;
}

/* Chart Count */
.saved-charts-count {
  text-align: right;
  color: #666;
  font-family: 'Orbitron', monospace;
  font-size: 11px;
  margin-top: 8px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .saved-charts-container {
    padding: 16px;
    margin-bottom: 16px;
  }

  .saved-charts-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .saved-charts-header h3 {
    font-size: 15px;
  }

  .refresh-charts-btn {
    align-self: flex-start;
    padding: 6px 10px;
    font-size: 11px;
  }

  .saved-charts-dropdown {
    font-size: 14px; /* Prevent zoom on iOS */
  }
}

@media (max-width: 480px) {
  .saved-charts-container {
    padding: 12px;
  }

  .saved-charts-header h3 {
    font-size: 14px;
  }

  .refresh-charts-btn {
    padding: 6px 8px;
    font-size: 10px;
  }
}

/* Print Styles */
@media print {
  .saved-charts-container {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/SavedCharts.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,yFAAyF;EACzF,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe,EAAE,wBAAwB;EAC3C;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* Saved Charts Container */\n.saved-charts-container {\n  background: linear-gradient(135deg, rgba(26, 26, 46, 0.8) 0%, rgba(22, 33, 62, 0.8) 100%);\n  border: 1px solid rgba(74, 124, 126, 0.3);\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 20px;\n  animation: slideDown 0.3s ease-out;\n  width: 100%;\n  max-width: 400px;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Header */\n.saved-charts-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid rgba(74, 124, 126, 0.2);\n}\n\n.saved-charts-header h3 {\n  margin: 0;\n  color: #fff;\n  font-family: 'Orbitron', monospace;\n  font-size: 16px;\n  font-weight: 700;\n  background: linear-gradient(135deg, #4a7c7e 0%, #7eb3b5 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Refresh Button */\n.refresh-charts-btn {\n  background: linear-gradient(135deg, #4a7c7e 0%, #7eb3b5 100%);\n  color: #000;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-family: 'Orbitron', monospace;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.refresh-charts-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(126, 179, 181, 0.3);\n}\n\n.refresh-charts-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Loading State */\n.saved-charts-loading,\n.saved-charts-loading-details {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 30px 20px;\n  gap: 12px;\n}\n\n.saved-charts-loading p,\n.saved-charts-loading-details p {\n  color: #aaa;\n  font-family: 'Orbitron', monospace;\n  font-size: 13px;\n  margin: 0;\n}\n\n/* Spinner */\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid rgba(74, 124, 126, 0.3);\n  border-top: 3px solid #7eb3b5;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Empty State */\n.saved-charts-empty {\n  padding: 20px;\n  text-align: center;\n  color: #999;\n  font-family: 'Orbitron', monospace;\n  font-size: 13px;\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  margin: 10px 0;\n}\n\n/* Dropdown Wrapper */\n.saved-charts-dropdown-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n/* Label */\n.saved-charts-label {\n  color: #ccc;\n  font-family: 'Orbitron', monospace;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Dropdown */\n.saved-charts-dropdown {\n  width: 100%;\n  padding: 10px 14px;\n  border: 2px solid #4a7c7e;\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.3);\n  color: #fff;\n  font-family: 'Orbitron', monospace;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.saved-charts-dropdown:focus {\n  outline: none;\n  border-color: #7eb3b5;\n  background: rgba(74, 124, 126, 0.1);\n  box-shadow: 0 0 10px rgba(126, 179, 181, 0.3);\n}\n\n.saved-charts-dropdown:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.saved-charts-dropdown option {\n  background: #16213e;\n  color: #fff;\n  padding: 8px;\n}\n\n/* Error Message */\n.saved-charts-error {\n  background: rgba(244, 67, 54, 0.1);\n  border: 1px solid rgba(244, 67, 54, 0.3);\n  color: #ff9999;\n  padding: 12px;\n  border-radius: 8px;\n  font-family: 'Orbitron', monospace;\n  font-size: 12px;\n  margin: 12px 0;\n}\n\n/* Info Message */\n.saved-charts-info {\n  background: rgba(76, 175, 80, 0.1);\n  border: 1px solid rgba(76, 175, 80, 0.3);\n  color: #9cff9c;\n  padding: 12px;\n  border-radius: 8px;\n  font-family: 'Orbitron', monospace;\n  font-size: 12px;\n  margin: 12px 0;\n  animation: slideDown 0.3s ease-out;\n}\n\n.saved-charts-info .info-text {\n  margin: 0;\n}\n\n/* Chart Count */\n.saved-charts-count {\n  text-align: right;\n  color: #666;\n  font-family: 'Orbitron', monospace;\n  font-size: 11px;\n  margin-top: 8px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .saved-charts-container {\n    padding: 16px;\n    margin-bottom: 16px;\n  }\n\n  .saved-charts-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .saved-charts-header h3 {\n    font-size: 15px;\n  }\n\n  .refresh-charts-btn {\n    align-self: flex-start;\n    padding: 6px 10px;\n    font-size: 11px;\n  }\n\n  .saved-charts-dropdown {\n    font-size: 14px; /* Prevent zoom on iOS */\n  }\n}\n\n@media (max-width: 480px) {\n  .saved-charts-container {\n    padding: 12px;\n  }\n\n  .saved-charts-header h3 {\n    font-size: 14px;\n  }\n\n  .refresh-charts-btn {\n    padding: 6px 8px;\n    font-size: 10px;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .saved-charts-container {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
